var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#D2D2D2;}\n\t.st2{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.4265;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:none;stroke:#BABABA;stroke-width:2.4265;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#BABABA;}\n\t.st5{fill:#CFCFCF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.3,90.9c-20.3,0-41-0.8-60.3-6.2c-19-5.3-36.4-15.5-51.9-27.3c-10.2-7.7-19.4-13.8-32.6-12.9 C55.6,45.2,43.2,50,33.3,58.3c-16.8,14.7-14.3,42-7.5,61c10.1,28.8,40.8,48.9,66.9,61.9c30.2,15.1,63.3,23.8,96.5,28.9 c29.1,4.4,66.5,7.6,91.8-11.4c23.2-17.5,29.5-57.4,23.9-84.3c-1.4-8-5.6-15.1-11.9-20.2c-16.3-11.9-40.6-4-58.9-3.6 C227.2,90.7,220.3,90.9,213.3,90.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.8,204.7H87.3V98.3l80.9-55.6l80.6,55.6V204.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M208.2,26.6L91.7,58.3c-3.7,1-5.8,4.8-4.8,8.5l26,95.5c1,3.7,4.8,5.8,8.5,4.8l116.5-31.7c3.7-1,5.8-4.8,4.8-8.5 l-26-95.5C215.7,27.7,211.9,25.6,208.2,26.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M248.8,205.3H87.3V99l76.8,48.7L248.8,99V205.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.3,205.3l76.1-72.8c1.4-1.4,3.4-2.2,5.4-2.2c2,0,3.9,0.8,5.4,2.2l74.6,72.8H87.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.8,109.7c-0.3-5.7,1.4-11.3,4.7-15.8c3.3-4.6,8.1-7.9,13.6-9.4c5.5-1.5,11.3-1.1,16.5,1.2 C184.7,88,189,92,191.6,97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186.1,68.4c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4 C182.7,66.9,184.2,68.4,186.1,68.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.3,82.8c1.9,0,3.4-1.5,3.4-3.4s-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4S131.4,82.8,133.3,82.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M245.8,63.3c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4 C243.4,62.2,244.5,63.3,245.8,63.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M75.1,184.9c1.3,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4S73.8,184.9,75.1,184.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.6,59.7v10.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M280.4,65h10.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M271.5,223.1v10.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M266.2,228.3h10.4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.3,7.1v10.4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.1,12.3h10.4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.6,257.2c49.2,0,89.1-2.5,89.1-5.6c0-3.1-39.9-5.6-89.1-5.6c-49.2,0-89.1,2.5-89.1,5.6 C75.5,254.7,115.4,257.2,164.6,257.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessages);
export default __webpack_public_path__ + "static/media/no-messages.a460cbd9f59021a56e1e55ef1f243073.svg";
export { ForwardRef as ReactComponent };